<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title48"></a>
<div class="p-c-br"><span>To my husband, also a cardiologist, <br/>who remembers things past</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781466815070_ded01.vue?c4c7a4f6